import { makeAutoObservable, runInAction } from 'mobx';
import { toast } from 'react-toastify';

import SubscriptionService from '../services/SubscriptionService';
import { RootStore } from './RootStore';

export class SingleSubscriptionStore {
  subscriptionService: InstanceType<typeof SubscriptionService>;

  constructor(private rootStore: RootStore) {
    this.subscriptionService = new SubscriptionService();
    makeAutoObservable(this, {}, { autoBind: true });
  }

  cancelSubscription = async (id: string) => {
    runInAction(() => this.rootStore.spinnerStore.showSpinner());
    try {
      const response = await this.subscriptionService.deleteSubscription(id);
      if (response && response.status === 204) {
        runInAction(() => {
          this.rootStore.subscriptionStore.updateSubscriptions();
          toast.success('Your Subscription is canceled.');
        });
      }
    } catch (error: any) {
      const message = error?.data?.title || 'failed to cancel';
      toast.error(message);
    } finally {
      runInAction(() => this.rootStore.spinnerStore.hideSpinner());
    }
  };
}
